module.exports = __webpack_public_path__ + "images/emoji/blowfish.8db4e3f53c79c7fc83f2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/blowfish.png
// module id = PnQr
// module chunks = 2